document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-mobile-menu-toggle]');
  if (!toggle) return;
  const menu = document.querySelector('[data-mobile-menu]');
  if (!menu) return;
  const open = menu.hasAttribute('open');
  if (open) {
    menu.removeAttribute('open');
    toggle.setAttribute('aria-expanded', 'false');
  } else {
    menu.setAttribute('open', '');
    toggle.setAttribute('aria-expanded', 'true');
  }
});

document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;
  const option = select.options[select.selectedIndex];
  const price = option.getAttribute('data-price');
  const available = option.getAttribute('data-available') === 'true';
  const form = select.closest('[data-product-form]');
  if (!form) return;
  const priceEl = form.querySelector('[data-product-price]');
  const submit = form.querySelector('[data-add-to-cart]');
  if (priceEl && price) priceEl.textContent = price;
  if (submit) {
    submit.disabled = !available;
    submit.textContent = available ? submit.getAttribute('data-add-label') : submit.getAttribute('data-sold-out-label');
  }
});
